import i18n from '@/plugins/i18n';

const setMainPageTitleAction = (title) => {
  document.title = title ? `${i18n.t('constants.welcomeTo')} ${title}` : i18n.t('constants.welcomeToCareClix');
};

const setFavIconAction = (iconPath) => {
  try {
    const link = document.querySelector("link[rel*='icon']");
    link.href = iconPath || 'favicon.ico';
  } catch (e) {
    return e;
  }
};

export default {
  namespaced: true,
  state: {
    isLogged: false,
    whiteLabel: null,
    appLoading: false,
    hideToolbar: true,
    hideSidebar: true,
    toolbarTitle: null,
    sidebarVisible: true,
    sidebarMini: false,
    sidebarMenuList: [],
    primaryColor: null,
    secondaryColor: null,
    versions: {
      countriesPhones: 'v1',
      allLanguages: 'v2',
    },
    initialHash: null,
  },
  getters: {
    phoneCodes: () => {
      const codes = JSON.parse(localStorage.getItem('phoneCodes'));
      return codes && codes.value;
    },
    countries: () => {
      const countries = JSON.parse(localStorage.getItem('countries'));
      return countries && countries.value;
    },
    allLanguages: () => {
      const allLanguages = JSON.parse(localStorage.getItem('allLanguages'));
      return allLanguages && allLanguages.value.map(lang => lang.name);
    },
    allLanguagesWithKeys: () => {
      const allLanguagesWithKeys = JSON.parse(localStorage.getItem('allLanguages'));
      return allLanguagesWithKeys && allLanguagesWithKeys.value;
    },
  },
  mutations: {
    setIsLogged: (state, payload) => state.isLogged = payload,
    setAppLoading: (state, payload) => state.appLoading = payload,
    setInitialHash: (state, payload) => state.initialHash = payload,
    setWhitelabel: (state, payload) => {
      setMainPageTitleAction(payload && payload.label ? payload.label : null);
      setFavIconAction(payload && payload.favicon ? payload.favicon : null);
      state.whiteLabel = payload;
    },
    setToolbarTitle(state, payload) {
      state.toolbarTitle = payload;
      state.hideToolbar = !!payload;
    },
    setHideToolbar: (state, payload) => state.hideToolbar = payload,
    setHideSidebar: (state, payload) => state.hideSidebar = payload,
    setSidebarMini: (state, payload) => state.sidebarMini = payload,
    setSidebarVisible: (state, payload) => state.sidebarVisible = payload,
    setSidebarMenuList: (state, payload) => state.sidebarMenuList = payload,
  },
};
